@if (visible()) {
<div class="docs-backdrop" (click)="close()"></div>
<div class="docs-overlay" [class.sidebar-collapsed]="!sidebarOpen()">

  <!-- sidebar / index -->
  <aside class="docs-sidebar" [class.open]="sidebarOpen()">
    <div class="sidebar-header">
      <h2>{{ 'docs.title' | t }}</h2>
      <button class="sidebar-toggle" (click)="toggleSidebar()" [attr.aria-label]="'docs.close-sidebar' | t">&times;</button>
    </div>

    <div class="sidebar-filter">
      <input
        type="text"
        [placeholder]="'docs.filter-placeholder' | t"
        [value]="filterText()"
        (input)="onFilter($event)"
        autocomplete="off"
        spellcheck="false"
      >
    </div>

    <nav class="sidebar-nav">
      @for (group of categories(); track group.category) {
        <div class="nav-group">
          <h3 class="nav-category">{{ group.category }}</h3>
          @for (doc of group.entries; track doc.file) {
            <button
              class="nav-item"
              [class.active]="activePage() === doc.file"
              (click)="loadPage(doc.file)"
            >{{ doc.title }}</button>
          }
        </div>
      }
    </nav>
  </aside>

  <!-- main content area -->
  <main class="docs-content">
    <div class="content-header">
      @if (!sidebarOpen()) {
        <button class="menu-btn" (click)="toggleSidebar()" [attr.aria-label]="'docs.open-sidebar' | t">
          <span class="menu-icon"></span>
        </button>
      }
      @if (activePage()) {
        <button class="back-btn" (click)="backToIndex()">{{ 'docs.index' | t }}</button>
      }
      <button class="close-btn" (click)="close()" [attr.aria-label]="'docs.close' | t">&times;</button>
    </div>

    @if (loading()) {
      <div class="docs-loading">{{ 'docs.loading' | t }}</div>
    } @else if (renderedHtml()) {
      <article class="docs-article" [innerHTML]="renderedHtml()"></article>
    } @else {
      <!-- welcome / index view when no doc is selected -->
      <div class="docs-welcome">
        <h1>{{ 'docs.main-title' | t }}</h1>
        <p>{{ 'docs.welcome-text' | t }}</p>
      </div>
    }
  </main>

</div>
}
